import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

import './Calculators.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const SIP = () => {
    const [sipAmount, setSipAmount] = useState(10000);
    const [duration, setDuration] = useState(120);
    const [returnRate, setReturnRate] = useState(14);
    const [results, setResults] = useState(null);
    const [pieData, setPieData] = useState(null);

    const calculateSIP = () => {
        let monthlyRate = returnRate / 100 / 12;
        let futureValue = sipAmount * ((Math.pow(1 + monthlyRate, duration) - 1) / monthlyRate) * (1 + monthlyRate);
        let investedAmount = sipAmount * duration;
        let growth = futureValue - investedAmount;

        setResults({
            futureValue: Math.round(futureValue),
            investedAmount: Math.round(investedAmount),
            growth: Math.round(growth),
        });

        // Setup Pie Chart
        setPieData({
            labels: ['Invested Amount', 'Growth'],
            datasets: [
                {
                    data: [investedAmount, growth],
                    backgroundColor: ['#004aad', '#76d041'],
                    borderWidth: 1,
                },
            ],
        });
    };

    return (
        <div className="sip-calculator">
            <h2>SIP Calculator</h2>

            <div className="input-group">
                <label>Monthly SIP Amount</label>
                <input type="range" min="1" max="100000" value={sipAmount} onChange={(e) => setSipAmount(Number(e.target.value))} />
                <input
                    type="number"
                    min="1"
                    max="100000"
                    value={sipAmount}
                    onChange={(e) => {
                        const val = e.target.value;
                        if (val === '') {
                            setSipAmount('');
                        } else {
                            setSipAmount(Number(val));
                        }
                    }}
                    className="value-box"
                />

            </div>

            <div className="input-group">
                <label>SIP Duration (Months)</label>
                <input type="range" min="1" max="500" value={duration} onChange={(e) => setDuration(Number(e.target.value))} />
                <input
                    type="number"
                    min="1"
                    max="500"
                    value={duration}
                    onChange={(e) => {
                        const val = e.target.value;
                        if (val === '') {
                            setDuration('');
                        } else {
                            setDuration(Number(val));
                        }
                    }}
                    className="value-box"
                />

            </div>

            <div className="input-group">
                <label>Expected Return (%)</label>
                <input type="range" min="1" max="100" value={returnRate} onChange={(e) => setReturnRate(Number(e.target.value))} />
                <input
                    type="number"
                    min="1"
                    max="100"
                    value={returnRate}
                    onChange={(e) => {
                        const val = e.target.value;
                        if (val === '') {
                            setReturnRate('');
                        } else {
                            setReturnRate(Number(val));
                        }
                    }}
                    className="value-box"
                />

            </div>

            <button className="calculate-btn" onClick={calculateSIP}>Calculate</button>

            {results && pieData && (
                <div className="sip-output-section">
                    <div className="result-summary">
                        <h3>SIP Planning</h3>
                        <p>Total Invested: <span>₹{results.investedAmount.toLocaleString()}</span></p>
                        <p>Total Growth: <span>₹{results.growth.toLocaleString()}</span></p>
                        <p>Total Future Value: <span>₹{results.futureValue.toLocaleString()}</span></p>
                    </div>

                    <div className="pie-chart-container">
                        <h3>Principal vs Growth</h3>
                        <Pie data={pieData} />
                    </div>
                </div>
            )}

        </div>
    );
};

export default SIP;

    